import { c as _c } from "react/compiler-runtime";
import useProductListingData from 'hooks/useProductListingData';
import { GET_CATEGORY_PAGE } from '@/graphql/queries';
import getVisitorLocationQueryVariables from 'commons/getVisitorLocationQueryVariables';
import useUserLocation from 'global-state/userLocation/useUserLocation';
import CLEARANCE_PAGE_SEO from 'components/consumer/category-page-algolia/clearancePageSeo';
const useClearancePageData = () => {
  const $ = _c(7);
  const userLocation = useUserLocation();
  const zipCode = userLocation?.zip ?? "";
  const t0 = userLocation?.stateShortName;
  let t1;
  if ($[0] !== t0) {
    t1 = getVisitorLocationQueryVariables(t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1 || $[3] !== zipCode) {
    t2 = {
      variables: {
        slug: "clearance",
        ...t1,
        zipCode
      }
    };
    $[2] = t1;
    $[3] = zipCode;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const pageData = useProductListingData(GET_CATEGORY_PAGE, t2);
  let t3;
  if ($[5] !== pageData) {
    t3 = {
      ...pageData,
      ...CLEARANCE_PAGE_SEO
    };
    $[5] = pageData;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default useClearancePageData;